import { NumberFormatter } from './NumberFormatter';

const convertToMoneyFormat = (num) => NumberFormatter.convertToNumberWithComma(num, 2);

const convertMoneyToNumber = (val) => Number(val.replace(',', '.'));

const convertEurocentsToMoneyFormat = (num) => convertToMoneyFormat(num / 100);

const convertMoneyToEurocents = (val) => (convertMoneyToNumber(val) * 100).toFixed(0);

const MoneyFormatter = {
  convertToMoneyFormat,
  convertMoneyToNumber,
  convertEurocentsToMoneyFormat,
  convertMoneyToEurocents,
};

export { MoneyFormatter };
